export const headerStyles = {
  TOP_CONTAINER:
    'flex flex-col md:flex-row items-center justify-center lg:space-x-16 bg-background',
  IMAGE: 'h-[40vh] md:h-full pt-6 md:pt-12 lg:min-w-[502px]',
  BUTTON: 'min-h-[24px] animate-jump-in animate-duration-1000',
  BOTTOM_CONTAINER: 'h-[30vh] flex justify-center items-center p-6 -mx-3 bg-secondary',
  BANNER: 'text-2xl md:text-3xl text-center text-white max-w-[80vw] animate-fade-up',
  HEADER: 'font-extrabold text-secondary dark:text-foreground text-center',
}

export const cardStyles = {
  MAIN_CONTAINER:
    'animate-fade rounded-3xl bg-background w-[300px] shadow-propital hover:scale-105 transform transition-all duration-500 ease-in-out',
  TITLE: 'font-extrabold text-secondary dark:text-foreground text-2xl max-w-[150px] mx-auto',
  BUTTON_CONTAINER: 'flex justify-center',
}
